import { render, staticRenderFns } from "./EntityViews.vue?vue&type=template&id=5bb6ac6a&scoped=true"
import script from "./EntityViews.vue?vue&type=script&lang=js"
export * from "./EntityViews.vue?vue&type=script&lang=js"
import style0 from "./EntityViews.vue?vue&type=style&index=0&id=5bb6ac6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6ac6a",
  null
  
)

export default component.exports